export const workflow = {
  errors: {
    noStep: 'No hay un paso actual en la respuesta',
    failedToExecute: 'Error al ejecutar el flujo de trabajo',
    failedToGoBack: 'Error al regresar',
  },
};
